import { useState } from "react";
import { useLocation } from "wouter";
import { Shield, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth-store";
import { api } from "@/lib/api/client";
import type { LoginResponse } from "@/lib/api/types";

export default function LoginPage() {
  const [, setLocation] = useLocation();
  const setSession = useAuth((s) => s.setSession);
  const [email, setEmail] = useState("admin@certicore.betrivasystems.com");
  const [password, setPassword] = useState("Cert1Pol_Admin_2026");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const data = await api.public<LoginResponse>("/auth/login", {
        method: "POST",
        body: { email, password },
      });
      setSession(data);
      // Redirige según rol
      const roleHome: Record<string, string> = {
        admin: "/admin",
        alumno: "/alumno",
        evaluador: "/evaluador",
        dictaminador: "/dictaminador",
        instructor: "/instructor",
        auditor: "/auditor",
        direccion: "/admin",
      };
      setLocation(roleHome[data.user.rol] ?? "/admin");
    } catch (err: any) {
      setError(err?.message ?? "Error de autenticación");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "radial-gradient(ellipse 80% 60% at 60% -10%, rgba(14,116,144,0.22) 0%, transparent 70%), radial-gradient(ellipse 50% 40% at -5% 50%, rgba(26,39,68,0.8) 0%, transparent 70%), #0a0e1a",
        fontFamily: "Inter, system-ui, sans-serif",
        padding: 24,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: 16,
          padding: 32,
          backdropFilter: "blur(20px)",
          boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              background: "linear-gradient(135deg, #1a2744 0%, #0e7490 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Shield size={20} color="white" />
          </div>
          <div>
            <div style={{ color: "white", fontWeight: 700, fontSize: 18, letterSpacing: -0.3 }}>
              CertiCore
            </div>
            <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 11, letterSpacing: 1, textTransform: "uppercase" }}>
              Plataforma de certificación
            </div>
          </div>
        </div>

        <h1 style={{ color: "white", fontSize: 22, fontWeight: 600, margin: "24px 0 6px" }}>
          Iniciar sesión
        </h1>
        <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 13, margin: "0 0 24px" }}>
          Accede a tu panel de operación CONOCER
        </p>

        <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <label style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 12, fontWeight: 500 }}>
              Correo institucional
            </span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              style={{
                background: "rgba(0,0,0,0.3)",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 8,
                padding: "10px 12px",
                color: "white",
                fontSize: 14,
                outline: "none",
              }}
            />
          </label>

          <label style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 12, fontWeight: 500 }}>
              Contraseña
            </span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              style={{
                background: "rgba(0,0,0,0.3)",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 8,
                padding: "10px 12px",
                color: "white",
                fontSize: 14,
                outline: "none",
              }}
            />
          </label>

          {error && (
            <div
              style={{
                color: "#fca5a5",
                background: "rgba(220,38,38,0.1)",
                border: "1px solid rgba(220,38,38,0.3)",
                borderRadius: 8,
                padding: "8px 12px",
                fontSize: 13,
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop: 6,
              background: "linear-gradient(135deg, #1a2744 0%, #0e7490 100%)",
              color: "white",
              border: "none",
              borderRadius: 8,
              padding: "11px 16px",
              fontSize: 14,
              fontWeight: 600,
              cursor: loading ? "wait" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            {loading ? "Verificando…" : "Entrar"}
          </button>
        </form>

        <div style={{ marginTop: 20, fontSize: 11, color: "rgba(255,255,255,0.4)", textAlign: "center" }}>
          v2 · staging · backend prod
        </div>
      </div>
    </div>
  );
}
